var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-main"},[_c('div',{staticClass:"header-bg"},[_c('el-container',{staticClass:"mh-less"},[_c('Header')],1)],1),_c('Home'),_c('el-container',{staticClass:"mh-less"},[_c('Register')],1),_c('el-container',{staticClass:"mh-less"},[_c('Schedule')],1),_c('el-container',{staticClass:"mh-less"},[_c('ContactUs')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }